import FinalCTA from "@/components/creatorshield/FinalCTA";
import Footer from "@/components/creatorshield/Footer";
import CaseStudies from "@/components/creatorshield/success-stories/CaseStudies";
import HeroSection from "@/components/creatorshield/success-stories/HeroSection";
import { useEffect } from "react";

export default function SuccessStories() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <HeroSection />
      <CaseStudies />
      <FinalCTA />
      <Footer />
    </div>
  );
}
